import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Feats = class Feats extends VuexModule {
    constructor() {
        super(...arguments);
        this.feats = [];
        this.cachedVersion = 0;
    }
    async fetchFeats() {
        const { data: feats, cachedVersion } = await fetchFromCache(this, 'feats', 'feat');
        return { feats, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['feats', 'cachedVersion'] })
], Feats.prototype, "fetchFeats", null);
Feats = __decorate([
    Module({ namespaced: true, name: 'feats' })
], Feats);
export default Feats;
